import { call, put } from 'redux-saga/effects';
import { requestFailed } from '~src/app/actions/RequestFailedAction';
import { requestSpaceContents } from '~src/app/actions/spaces/RequestSpaceContentsActions';
import { SetTabsWorkbookAction } from '~src/app/actions/spaces/SetTabsWorkbookAction';
import { Messages } from '~src/codegen/Localize';
import { SetDisplayTabsAction } from '~src/content/services/SetDisplayTabsAction';
import { IWorkbookInfo } from '~src/ts/models/IWorkbookInfo';
import { Set } from '~src/ts/models/Set';

import { reloadSpaceIfUpdatingCurrentSpace } from '../content/RefreshContentSagas';
import { getWorkbookInfos } from '../SpacesSagaHelpers';

export function* setTabsWorkbookSaga(action: SetTabsWorkbookAction) {
    const localizedErrorMessage = Messages.unexpectedError();
    try {
      const workbookInfos = yield getWorkbookInfos(action.workbooks);
      // errors are handled by the dialog - nothing to be done on success
      yield call(openSetTabsWorkbookDialog, workbookInfos);

      const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.workbooks);
      if (!maybeReloaded) {
        yield put(requestSpaceContents());
      }

    } catch(e) {
      yield put(requestFailed(e, localizedErrorMessage));
    }
  }

function openSetTabsWorkbookDialog(workbooks: IWorkbookInfo[]): Promise<any> {
    const workbooksSet = Set.fromIdItemArray(workbooks);
    return SetDisplayTabsAction.confirmSetDisplayTabs(workbooksSet);
  }
